import { useModal } from '@ebay/nice-modal-react';
import { modalIds } from '@shared/config/modal-ids';

export const useComplectationInfoModal = () => {
  const modal = useModal(modalIds.complectationInfoModalId);

  return modal;
};
